// Mirrors the constants defined in Base/src/main/java/com/bobex/model/CRMCategoryModel.java
// Values reference rows in t_crmcategory.
export const CRMCategoryConstants = {
    DEFAULT_CATEGORY: 50,        // Account (default category used when none is selected)
    CATEGORY_UNPAIDINVOICE: 20,  // Unpaid Invoice (used by Send to Lawyer last-comment filter)
    CATEGORY_LEAD: 30,
} as const;
